// extracted by mini-css-extract-plugin
module.exports = {"label":"Upload_label__iRQcd","footer":"Upload_footer__Aml1u"};